import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { projects } from './data/projectsData';
import { experiences } from './data/experince';
import Header from './components/Header/Header';
import About from './components/About';
import Projects from './components/Projects';
import Tech from './components/Tech';
import Resume from './components/Resume';
import Experience from './components/Experience';
import Footer from './components/Footer';

function App() {
	const firstThreeProjects = projects.slice(0, 3);

	return (
		<div className="w-full h-full m-auto font-light text-smoke-white">
			<Header />
			<Routes>
				<Route
					path="/"
					element={
						<>
							<About />
							<Projects projects={firstThreeProjects} root={'root'} />
							<Tech />
							<Resume />
						</>
					}
				/>
				<Route path="/projects" element={<Projects projects={projects} />} />
				<Route
					path="/experiences"
					element={<Experience experiences={experiences} />}
				/>
			</Routes>
			<Footer />
		</div>
	);
}

export default App;
